<template>
  <div class="bg-white py-4 px-6">
    <div
      class="flex items-center justify-between cursor-pointer"
      @click="collapsed = !collapsed"
    >
      <div class="text-xl font-semibold text-blue-800">
        {{ $t("bodyprint_info.header") }}
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="text-blue-800"
        :style="{
          transition: 'transform 0.2s',
          transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)'
        }"
      >
        <path
          fill-rule="evenodd"
          d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <div class="w-full h-1 bg-gray-400 mt-2" />
    <div v-show="!collapsed" class="grid grid-cols-7 py-2 break-words">
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.user") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.user.name }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.email") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.user.email }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.user_permission") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.user.permission }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.retailer_code") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.retailer_code }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.blur_status") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.bodyprint.blur_status }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.created_at") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.created_at }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.last_updated_at") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.last_updated_at }}</p>
      <p class="col-span-3 font-bold">
        {{ $t("bodyprint_info.data.labels.last_editor") }}
      </p>
      <p class="col-span-4">{{ getBodyprintInfo.last_editor }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      getBodyprintInfo: "bodyprint/getBodyPrintInfo"
    })
  },
  props: {},
  data() {
    return {
      collapsed: true
    };
  }
};
</script>

<style></style>
